import { render, staticRenderFns } from "./PhoneCallsMultiSelect.component.vue?vue&type=template&id=ec43c96a&scoped=true&"
import script from "./PhoneCallsMultiSelect.component.vue?vue&type=script&lang=js&"
export * from "./PhoneCallsMultiSelect.component.vue?vue&type=script&lang=js&"
import style0 from "./PhoneCallsMultiSelect.component.vue?vue&type=style&index=0&id=ec43c96a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec43c96a",
  null
  
)

export default component.exports